export const LABS_PATIENT_REFRESH_TOAST = {
  missingClientId: {
    title: "Refresh failed",
    message: "Client could not be identified. Reload the page and try again.",
  },
  reloadFailed: {
    title: "Refresh failed",
    message: "Unable to reload client information. Please try again.",
  },
} as const;

export const LABS_RESULTS_FETCH_TOAST = {
  loadFailed: {
    title: "Couldn't load results",
    message: "The lab order list could not be loaded. Refresh to try again.",
  },
  refreshFailed: {
    title: "Refresh failed",
    message:
      "The lab order list could not be updated, so it still shows the orders loaded earlier. Please try again.",
  },
} as const;
